// extracted by mini-css-extract-plugin
export default {"price":"x7-z","onSale":"y7-z","msrpLabelPrice":"z7-z","msrpLabel":"A7-z","originalPrice":"B7-z","percentOff":"C7-z"};